document.addEventListener('DOMContentLoaded', e => {
    let cartTotalsObserver;
    let isReloading = false; // Прапорець для запобігання подвійному перезавантаженню

    const initCartTotalsObserver = (targetNode) => {
        const cartTotals = targetNode.querySelector('.cart_totals');
        if (!cartTotals) return;
        if (cartTotalsObserver) {
            cartTotalsObserver.disconnect();
        }
        const setCartTotalsHeight = () => {
            const height = cartTotals.offsetHeight;
            document.body.style.setProperty('--cart-totals-height', `${height}px`);
        };
        setCartTotalsHeight();
        cartTotalsObserver = new ResizeObserver(setCartTotalsHeight);
        cartTotalsObserver.observe(cartTotals);
    };
    initCartTotalsObserver(document.body);

    // Виконуємо скрипт тільки на сторінці кошика
    if (!document.body.classList.contains('woocommerce-cart')) {
        return;
    }

    // Запам'ятовуємо, чи був кошик з товарами при завантаженні сторінки.
    const wasCartInitiallyPopulated = !!document.querySelector('form.woocommerce-cart-form');

    // Якщо кошик спочатку був порожній, нічого не робимо.
    if (!wasCartInitiallyPopulated) {
        return;
    }

    // Створюємо MutationObserver для відстеження видалення форми кошика.
    const cartContainer = document.querySelector('.woocommerce');
    const observer = new MutationObserver((mutationsList, observer) => {
        // Перевіряємо, чи була видалена форма кошика.
        const cartForm = document.querySelector('form.woocommerce-cart-form');
        if (wasCartInitiallyPopulated && !cartForm && !isReloading) {
            isReloading = true;
            window.location.reload();
            observer.disconnect();
        }
    });

    // Починаємо спостереження, якщо кошик був з товарами і є контейнер.
    if (wasCartInitiallyPopulated && cartContainer) {
        observer.observe(cartContainer, { childList: true, subtree: true });
    }

});
